export const roleOptions = [
	{
		label: 'Founder/Co-Founder',
		value: 0,
	},
	{
		label: 'Treasury Manager/Analyst',
		value: 1,
	},
	{
		label: 'Accountant/Bookkeeper',
		value: 2,
	},
	{
		label: 'CFO/Finance Manager',
		value: 3,
	},
	{
		label: 'Auditor',
		value: 4,
	},
	{
		label: 'Administrator',
		value: 5,
	},
	{
		label: 'Community Member',
		value: 6,
	},
	{
		label: 'Software Engineer',
		value: 7,
	},
	{
		label: 'Other',
		value: 8,
	},
];
